module.exports = __webpack_public_path__ + "img/Group 11414.158b82d9.svg";